var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourthChristmas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6388 10.4579L20.3174 10.0748L19.9344 10.3962L9.20622 19.3982L8.8232 19.7196L9.1446 20.1026L34.7413 50.6076L35.0627 50.9906L35.4457 50.6692L46.1739 41.6672L46.5569 41.3458L46.2355 40.9628L20.6388 10.4579Z",
    fill: "#BB8948",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.399 15.3241L15.0628 15.4876L15.0175 14.8054L14.6237 8.88486L14.6237 8.8846L14.227 2.96652L14.1612 1.98391L13.4068 2.61694L8.0412 7.11918L2.67861 11.6189L1.9242 12.252L2.88044 12.4874L8.63972 13.9058L14.399 15.3241Z",
    fill: "#BB8948",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8932 45.6426L40.2293 45.4795L40.275 46.1616L40.6717 52.0797L41.0684 57.9978L41.1342 58.9804L41.8887 58.3474L47.2512 53.8476L52.6168 49.3454L53.3712 48.7123L52.415 48.4768L46.6557 47.0585L46.6554 47.0585L40.8932 45.6426Z",
    fill: "#BB8948",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthChristmas);
export default __webpack_public_path__ + "static/media/fourthChristmas.7c48b7a39a12c4a166f6e60c77cc29a3.svg";
export { ForwardRef as ReactComponent };